import { common } from 'database/db'
import { dbCurrentEntries } from 'config/constants'
import moment from 'moment'
import { StructureDataResponseType } from 'types'

export async function saveStructureDb(structure: StructureDataResponseType) {
  try {
    const result = await common.dcaStructure.put({
      name: dbCurrentEntries.STRUCTURE,
      export: structure.export,
      language: structure.language,
      createdAt: structure.createdAt,
      country: structure.country,
      year: structure.year,
      syncAt: moment().startOf('day').format(),
      data: structure.data,
    })
    return {
      structure: result,
    }
  } catch (error) {
    console.error('saveStructureDb', error)
    throw error
  }
}
